import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PymeInfoPage } from './pyme-info.page';

const routes: Routes = [
  {
    path: '',
    component: PymeInfoPage,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PymeInfoPageRoutingModule {
}
